import { modifyLinkBehavior } from '../utils.js';

export default function () {
  const widgetName = 'headerButtonWidget';
  const widgetOpts = headerButtonWidgetOpts;
  const $widgetHTML = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($widgetHTML, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: true,
    cardWidgetLoaded: function (data, _owl, hasData) {
      const cards = $(`#${widgetName} .card-widget-item`);
      const noURL = data.items[0]?.URL === null;
      if (!hasData || noURL) {
        $widgetHTML.parent().hide();
        $widgetHTML.remove();
      } else {
        modifyLinkBehavior(data, cards);
      }
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: ['all'],
    maxItemsVisible: 1,
    moreButton: false,
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: true,
  });
}
